export default "__VITE_ASSET__CXLXNgN5__"